module.exports = __webpack_public_path__ + "img/percentages@2x.02fc3f5c.png";